import { connect } from "react-redux";
import Announcements from "./Announcements";

const mapStateToProps = state => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Announcements);
